<template>
  <div class="main-content pay-table">
    <div class="dropdown">
      <DatePicker
        v-model="searchObj.selectDate"
        type="daterange"
        placeholder="归来日期"
        style="width: 200px"
      ></DatePicker>
      <i-select
        v-model="searchObj.supplyId"
        multiple
        filterable
        clearable
        style="width: 200px"
        placeholder="供应商"
        clearable
      >
        <i-option
          v-for="(val, key) in supplyList"
          :label="val"
          :value="key"
          :key="key"
        >
        </i-option>
      </i-select>
      <i-select
        v-model="searchObj.location"
        multiple
        filterable
        clearable
        style="width: 200px"
        placeholder="国家"
        clearable
      >
        <i-option
          v-for="item of destinations"
          :label="item.name"
          :value="item.id"
          :key="item.id"
        >
        </i-option>
      </i-select>
      <Button type="primary" @click="getDataList()"> 查询 </Button>
    </div>
    <exportExcel
      :has-data="dataList.length"
      :params="params"
      res-api="downloadBackReport"
    ></exportExcel>
    <div class="table-wrap">
      <Table border :columns="columns" :data="dataList" ref="all"></Table>
    </div>
    <pager :total="+pageCount" @change="getDataList"></pager>
  </div>
</template>
<script>
import pager from "./pager.vue";
import exportExcel from "./exportExcel.vue";
import {
  dateFormat,
  getAllCountrys,
  getList,
  getSupplyList,
  initTableHeader,
  notAllowEmpty,
  renderBtn,
  renderColumn,
  renderShow,
  sendRequest,
} from "./util.js";

// 报表3 归来维度 供应商分析
export default {
  name: "backVendorTable",
  components: { pager, exportExcel },
  data() {
    return {
      supplyList: [],
      destinations: [],
      resourceTypes: [],
      pageCount: 0,
      payList: [],
      searchObj: {
        supplyId: [],
        location: [],
        resource: "",
        payStyle: "",
        selectDate: "",
      },
      warnMsgObj: { selectDate: "归来日期不能为空" },
      dataList: [],
      columns: [],
      titleKeys: {
        vendor_name: "供应商名称",
        destination: "目的地",
        back_date: "归来日期",
        settlement_mode_name: "结算方式",
        pay_origin: "应付金额（原币）",
        pay_currency: "应付币种",
        pay_rmb: "应付金额（人民币）",
        paid_origin: "实付金额（原币)",
        paid_currency: "实付币种",
        paid_rmb: "实付金额（人民币）",
        payable_origin: "应付未付金额（原币）",
        payable_currency: "应付未付币种",
        payable_rmb: "应付未付金额（人民币）",
        rate_diff: "汇率差",
        payable_id_list: "采购单明细",
      },
      params: {},
    };
  },
  methods: {
    async init() {
      this.supplyList = await getSupplyList();
      this.destinations = await getAllCountrys();
    },
    btnCallBack(params) {
      this.$router.push({
        name: "purchaseDetail",
        params: { purchaseId: params.row.payable_id_list, hasRateDiff: true },
      });
    },
    async getDataList(pageNo = 1, pageSize = 20) {
      const { selectDate, supplyId, location } = this.searchObj;
      if (
        selectDate.filter((val) => val.length === 0).length ===
        selectDate.length
      ) {
        this.$Message.warning("归来日期不能为空");
        return;
      }
      const requestParams = {
        back_date_start: dateFormat(selectDate[0]),
        back_date_end: dateFormat(selectDate[1]),
        vendor_id: supplyId,
        country: location,
        page: pageNo,
        page_num: pageSize,
      };
      this.params = requestParams;
      this.params.hasRateDiff = 1;
      const datas = await getList("backReport", requestParams);
      this.dataList = datas.list;
      this.pageCount = datas.count;
    },
  },
  mounted() {
    this.columns = initTableHeader(this.titleKeys);
    renderColumn(
      this.columns,
      "payable_id_list",
      "render",
      renderBtn(this.btnCallBack)
    );
    this.init();
  },
};
</script>

<style></style>
